import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import type { ModalProps as MuiModalProps } from "@mui/material/Modal";
import { default as MuiModal } from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  maxWidth: "min(calc(100vw - 30px), 500px)",
  boxShadow: 24,
  borderRadius: "15px",
  py: 10,
  p: 4,
};

export default function Modal({ open = true, children, ...props }: MuiModalProps) {
  return (
    <MuiModal
      open={open}
      closeAfterTransition
      disableAutoFocus={true}
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
      {...props}
    >
      <Fade in={open}>
        <Box sx={style}>{children}</Box>
      </Fade>
    </MuiModal>
  );
}
